export const MODEL_PORTFOLIOS_LIST_APP_STATE_SLICE_KEY = 'modelPortfoliosList';
export const MODEL_PORTFOLIOS_LIST_STATE_KEYS = [
    'benchmark',
    'owner',
    'portfolioType',
    'editState',
    'name',
    'sortColumn',
    'sortDirection',
    'watchlistId',
    'page',
    'viewRootFolder',
    'includeEmptyFolders',
];
// The system default state excludes sortColumn and sortDirection
export const MODEL_PORTFOLIOS_LIST_SYSTEM_DEFAULT_STATE = {
    benchmark: '',
    owner: {
        me: true,
        shared_with_me: true,
        public: true,
    },
    portfolioType: {
        blended_benchmark: true,
        client_portfolio: true,
        model_portfolio: true,
        household_portfolio: true,
    },
    editState: {
        completed: true,
        draft: true,
    },
    name: '',
    watchlistId: null,
    viewRootFolder: null,
    includeEmptyFolders: true,
};
